import React from 'react';
import PropTypes from 'prop-types';

export default function LockIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 152 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="padlock">
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M129.647 70.5H116.222V39.6637C116.222 17.793 98.1719 0 75.9862 0C53.8005 0 35.7509 17.793 35.7509 39.6637V70.5H22.3529C10.0275 70.5 0 80.5935 0 93V169.5C0 181.906 10.0275 192 22.3529 192H129.647C141.972 192 152 181.906 152 169.5V93C152 80.5935 141.972 70.5 129.647 70.5ZM50.6529 39.6637C50.6529 26.064 62.0175 15 75.9862 15C89.9549 15 101.32 26.064 101.32 39.6637V70.5H50.6529V39.6637ZM129.647 177C133.756 177 137.098 173.635 137.098 169.5V93C137.098 88.8645 133.756 85.5 129.647 85.5H22.3529C18.2445 85.5 14.902 88.8645 14.902 93V169.5C14.902 173.635 18.2445 177 22.3529 177H129.647Z"
          fill={color}
        />
        <path
          id="Path"
          d="M79 106C71.8201 106 66 111.773 66 118.894C66 123.441 68.3751 127.435 71.96 129.731V145.03C71.96 148.879 75.106 152 78.987 152C82.8677 152 86.014 148.879 86.014 145.03V129.747C89.6133 127.454 92 123.452 92 118.894C92 111.773 86.1799 106 79 106Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

LockIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

LockIcon.defaultProps = {
  width: 152,
  height: 192,
  color: '#FFFFFF',
};
